const HotelBookings = [
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "USA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "FRA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "NULL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ROU",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ROU",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "NOR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "NOR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "OMN",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ARG",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "USA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "USA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "POL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "DEU",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "FRA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "USA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "BEL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "DEU",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "FRA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 1,
      "children": 2,
      "babies": 0,
      "country": "FRA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 1,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "CHE",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 1,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 4,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "FRA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "FRA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "FRA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "DEU",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "DEU",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "FRA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "CN",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "CHE",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "USA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "CN",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "CHE",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 1,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "USA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "USA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GRC",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "FRA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ITA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "07",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "07",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "07",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "07",
      "adults": 3,
      "children": 2,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "07",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "USA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "NLD",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "08",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "CHE",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "08",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "08",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "DNK",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "DNK",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "09",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "ARG",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 0,
      "babies": 1,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "09",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "RUS",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "SWE",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "POL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "FRA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "USA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "AUS",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "POL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 0,
      "babies": 2,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "EST",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "RUS",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 1,
      "babies": 1,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 3,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 0,
      "babies": 1,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "DNK",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "10",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 2,
      "children": 0,
      "babies": 1,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "CZE",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "DEU",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ROU",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "11",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "CN",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "BRA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 1,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 3,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 1,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "FRA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 10,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "BEL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "FRA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "BEL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ITA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "FRA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 1,
      "country": "FIN",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "CN",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "12",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 1,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "AUS",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 4,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "USA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "FRA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ROU",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "FIN",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "13",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "14",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "14",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "14",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "14",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "14",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "14",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "14",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "POL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "14",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "14",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "14",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "14",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "14",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "14",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "14",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "14",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "14",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "14",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "14",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "14",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "SWE",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "14",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "SWE",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "14",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "14",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "15",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "15",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "15",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "POL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "15",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "15",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "15",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "15",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "15",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "15",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "15",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "15",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "15",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "15",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "15",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "15",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "15",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "15",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "15",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "15",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "15",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "15",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "15",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "15",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "15",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "15",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "15",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "16",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "16",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "DNK",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "16",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "FIN",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "16",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "16",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "16",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "USA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "16",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "16",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "16",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "16",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "DNK",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "16",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "16",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "16",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "16",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "16",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "16",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "16",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "16",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "16",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "16",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "16",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "16",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "16",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "16",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "16",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 3,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "FRA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "MOZ",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "BWA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "DEU",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "MOZ",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "17",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "LUX",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 0,
      "babies": 1,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 1,
      "babies": 1,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 1,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "CN",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "18",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "NLD",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "RUS",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "19",
      "adults": 2,
      "children": 0,
      "babies": 1,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 0,
      "babies": 1,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "POL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "NOR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 0,
      "babies": 1,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "20",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "21",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "21",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "21",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "21",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "21",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "21",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "21",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "21",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "21",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "CHE",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "21",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "21",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "21",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "22",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "22",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "22",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "22",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "FRA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "22",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "22",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "22",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "23",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "23",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "23",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "23",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "23",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "23",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "23",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "23",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "23",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "23",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "23",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "23",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "CN",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "23",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "23",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "23",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "ROU",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "BRA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "BRA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "RUS",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "SVN",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ALB",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "24",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "25",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "26",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "26",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "26",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "26",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "CN",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "26",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "26",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "26",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "26",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "26",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "26",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "26",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "RUS",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "26",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "26",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "26",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "26",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "27",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "28",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "28",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "USA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "28",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "28",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "28",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "28",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "28",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "RUS",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "28",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "28",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "28",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "28",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "28",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "NOR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "28",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "28",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "USA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "29",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "29",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "29",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "29",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "29",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "29",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "29",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "29",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "29",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "29",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "29",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "29",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "29",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "29",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "29",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "29",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "29",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "29",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "29",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "29",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "30",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "30",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "30",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "30",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "30",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "30",
      "adults": 3,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "30",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "30",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "30",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "30",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "30",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "BRA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "30",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "30",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "30",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "30",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "30",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "30",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "30",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "CHE",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "30",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "CHE",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "30",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "NLD",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "BEL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "07",
      "arrival_date_day_of_month": "31",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "01",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "02",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "02",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 1,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "03",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "03",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "04",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 1,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "04",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "RUS",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "05",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "05",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 1,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "05",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "06",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "FRA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "06",
      "adults": 3,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ROU",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "RUS",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "06",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "06",
      "adults": 3,
      "children": 1,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "IND",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "GBR",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 1,
      "babies": 1,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "07",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "NLD",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "CHN",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "CHE",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "USA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "ESP",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "FRA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 2,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 1,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "IRL",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "08",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "FRA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 1,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "FRA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "USA",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "CN",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "09",
      "adults": 1,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "MEX",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 0,
      "babies": 0,
      "country": "PRT",
    },
    {
      "hotel": "Resort Hotel",
      "arrival_date_year": 2015,
      "arrival_date_month": "08",
      "arrival_date_day_of_month": "09",
      "adults": 2,
      "children": 1,
      "babies": 1,
      "country": "ESP",
    }
  ]

  export default HotelBookings;